import isEmpty from 'lodash/isEmpty';
import flowRight from 'lodash/flowRight';

import { connect } from 'react-redux';
import { withReduxForm } from '@eventbrite/eds-form';

import RefundsForm from '../components/RefundsForm';
import { formValidate as validate } from '../utils';
import {
    clearRefundNotification,
    createRefundRequest,
} from '../actions/refunds';

import { REFUND_REQUESTS_FORM } from '../constants';
import {
    getAttendeeRefundRequirementsLink,
    getFeatureFlags,
    getHowToGetARefundLink,
    getRecaptchaV2Key,
    getWhereAreMyTicketsLink,
} from '../selectors';

const _mapStateToProps = ({
    refundNotificationOptions,
    disableSubmitButton,
    hideCaptcha,
    ...state
}) => ({
    initialValues: {
        attendeeEmail: '',
        orderId: '',
    },
    learnMoreLink: getWhereAreMyTicketsLink(state),
    recaptcha2PublicKey: getRecaptchaV2Key(state),
    refundInformationLink: getHowToGetARefundLink(state),
    attendeeRefundRequirementsLink: getAttendeeRefundRequirementsLink(state),
    featureFlags: getFeatureFlags(state),
    refundNotificationOptions,
    hideCaptcha,
    submitIsDisabled: disableSubmitButton,
    shouldRenderRefundNotification: !isEmpty(refundNotificationOptions),
});

const _mapDispatchToProps = {
    onSubmit: createRefundRequest,
    clearRefundNotification,
};

const _enhance = flowRight(
    connect(_mapStateToProps, _mapDispatchToProps),
    withReduxForm({ validate, form: REFUND_REQUESTS_FORM }),
);

export default _enhance(RefundsForm);
